import React, { FC, useEffect, useMemo } from 'react';
import { Container } from 'reactstrap';

import CenteredLoader from '../../components/CenteredLoader/CenteredLoader';
import DestinationList from '../../components/Destinations/DestinationList';
import Helmet from '../../components/common/Helmet';
import Map from '../../containers/Map';
import useTranslate from '../../hooks/useTranslate';
import { useGolfCourseCountries } from '../../services/apis/countries/api';
import useGolfCourses from '../../services/apis/golfCourses/api';

const CountriesPage: FC = () => {
  const { data: golfCourses, isLoading } = useGolfCourses();
  const golfCourseCountries = useGolfCourseCountries();
  const { translate, activeLanguage } = useTranslate();

  useEffect(() => {
    document.body.classList.add('new-site');
    return () => {
      document.body.classList.remove('new-site');
    };
  }, []);

  const destinations = useMemo(
    () =>
      golfCourseCountries.map(country => ({
        ...country,
        url: `/${activeLanguage.code}/courses/countries/${country.name}`,
      })),
    [activeLanguage.code, golfCourseCountries]
  );
  const mapCourses = useMemo(() => golfCourses?.map(c => ({ ...c, marked: true })), [golfCourses]);
  const nrOfCountries = golfCourseCountries?.length;

  return (
    <>
      <Helmet
        titleTranslationKey="Country.Title"
        titleData={{ countryAmount: nrOfCountries }}
        descriptionTranslationKey="Country.helmetDescription"
        descriptionData={{ countryAmount: nrOfCountries }}
      />

      {!isLoading && mapCourses && (
        <>
          <div className="mt-2 mb-5">
            <Map courses={mapCourses} hoveredCourse={null} />
          </div>
          <Container className="mb-5">
            <h1>{translate('Country.Title', { countryAmount: nrOfCountries })}</h1>
            <DestinationList items={destinations} />
          </Container>
        </>
      )}

      {isLoading && <CenteredLoader message={String(translate('Courses.LoadingGolfCourses'))} />}
    </>
  );
};

export default CountriesPage;
